export const AddMenuKeys = {
  AddMenuItems: 'addMenuItems',
};
